import React, { useMemo } from 'react';
import { number, shape, string } from 'prop-types';
import styles from './bullets.module.css';
import { is } from '../../lib/is.js';

Bullets.propTypes = {
	currentSlide: shape({ index: number }),
	total: number,
	align: string,
};

export default function Bullets (props) {
	const {
		total = 0,
		align,
		currentSlide,
	} = props;
	const fakeArr = useMemo(() => new Array(total).fill(true), [ total ]);

	if (total < 2) {
		return null;
	}

	if (!currentSlide) {
		return null;
	}
	return (
		<section className={styles[align]} data-visible={is.slideDisplayMode.fullscreen(currentSlide)}>
			{fakeArr.map((_, index) => (
				<span key={index} className={styles.bullet} data-is-active={index === currentSlide.bulletIndex} />
			))}
		</section>
	);
}
